import { Navigate } from 'react-router-dom'; 
import { useAuth } from './AuthContext'; 

export default function ProtectedRoute({ children }) { 
  const { user, session, authLoading } = useAuth(); 
  
  if (authLoading) { 
    return <div>Loading...</div>; } 
  if (!session || !user) { 
    return <Navigate to="/login" replace />; 
  } 
  return children; }